import { Controller } from "@hotwired/stimulus"

// Two-state collapse/expand: a `trigger` button and a `panel`. Clicking
// the trigger hides it and shows the panel; the panel's close button
// (via `close` action) does the reverse. Used by the Add-a-brand ghost
// card on the Group Detail page.
export default class extends Controller {
  static targets = ["trigger", "panel"]

  open() {
    this.triggerTarget?.classList.add("hidden")
    this.panelTarget?.classList.remove("hidden")
    const firstField = this.panelTarget?.querySelector("input[type='text'], input[type='url']")
    firstField?.focus()
  }

  close() {
    this.panelTarget?.classList.add("hidden")
    this.triggerTarget?.classList.remove("hidden")
  }
}
